import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { Divider } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MDProductPercentageDialog({
  product,
  onAgree,
  customButton, // JSX element for the custom button
}) {
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState(0);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAgreePercentage = () => {
    let productAmount = ((product?.premiumPercentage / 100) * amount).toFixed(
      2
    );
    onAgree(productAmount);
    handleClose();
  };

  const handleAgreeFixed = () => {
    let productAmount = parseInt(product?.amount).toFixed(2);
    onAgree(productAmount);
    handleClose();
  };

  const changeHandler = (e) => {
    setAmount(e.target.value);
  };

  return (
    <MDBox>
      <div onClick={handleOpen}>{customButton}</div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        fullWidth={true}
        maxWidth="xl"
        color="info"
        aria-labelledby="responsive-dialog-title"
      >
        {product?.premiumPercentage > 0 ? (
          <MDTypography variant="text" color="dark" mx="auto" pt={5}>
            This product contains options for a fixed amount of a percentage of
            value. Select your preferred option:
          </MDTypography>
        ) : (
          <MDTypography variant="text" color="dark" mx="auto" pt={5}>
            This product contains a fixed amount value. Select proceed below:
          </MDTypography>
        )}
        <MDBox display="flex" p={5}>
          <MDBox
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
            sx={{ padding: 5 }}
            mx="auto"
          >
            <DialogTitle id="responsive-dialog-title" minWidth={450}>
              <MDTypography variant="text" color="dark">
                Fixed Price
              </MDTypography>
            </DialogTitle>
            <DialogContent>
              <DialogContentText mb={11}>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="dark"
                >
                  *Not including addons
                </MDTypography>
              </DialogContentText>
              <DialogContentText>
                <MDTypography
                  variant="h4"
                  fontWeight="regular"
                  color="dark"
                  pt={5}
                >
                  Ksh. {parseInt(product?.amount).toFixed(2)}
                </MDTypography>
              </DialogContentText>
            </DialogContent>
            <DialogActions bottom={0}>
              <MDButton onClick={handleClose}>Cancel</MDButton>
              <MDButton onClick={handleAgreeFixed}>Proceed to Order</MDButton>
            </DialogActions>
          </MDBox>

          <Divider orientation="vertical" />

          {product?.premiumPercentage > 0 && (
            <MDBox
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              sx={{ padding: 5 }}
              mx="auto"
            >
              <DialogTitle id="responsive-dialog-title" minWidth={450}>
                <MDTypography variant="text" color="dark">
                  {product?.premiumPercentage}% Percent of Value Amount
                </MDTypography>
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="dark"
                  >
                    *Not including addons
                  </MDTypography>
                </DialogContentText>
                <DialogContentText>
                  <MDBox pt={5}>
                    <MDInput
                      type="number"
                      label="Value amount"
                      placeholder="Enter your Value amount"
                      fullWidth
                      name="amount"
                      value={amount}
                      onChange={changeHandler}
                    />
                  </MDBox>
                  <MDTypography
                    variant="h4"
                    fontWeight="regular"
                    color="dark"
                    pt={5}
                  >
                    Ksh.{" "}
                    {((product?.premiumPercentage / 100) * amount).toFixed(2)}
                  </MDTypography>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <MDButton onClick={handleClose}>Cancel</MDButton>
                <MDButton onClick={handleAgreePercentage}>
                  Proceed To Order
                </MDButton>
              </DialogActions>
            </MDBox>
          )}
        </MDBox>
      </Dialog>
    </MDBox>
  );
}
